// Prevent exporting storefront images through native browser drag and drop.
// Pointer/touch interactions in the customizer and incoming file uploads are unaffected.
document.addEventListener('dragstart', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;
  const image = target.closest('img, picture, canvas, svg');
  const link = target.closest('a');
  const imageLink = link && (link.querySelector('img, picture') || /\.(?:avif|gif|jpe?g|png|svg|webp)(?:[?#]|$)/i.test(link.getAttribute('href') || ''));
  if (image || imageLink) event.preventDefault();
}, true);
